import { SvgIcon, SvgIconProps } from './SvgIcon';

export const ArrowUpIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d="M10 4L5.5 8M10 4L14.5 8M10 4V16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
